export const API_TOKEN = process.env.REACT_APP_API_TOKEN ?? '0dda3bbd44455ef6891ff878bb5cea06006a9af2'
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? 'https://api.joinmytalent.com/api/_ext/?call=/api'
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL ?? 'http://localhost:3000/graphql'
export const FE_URL = process.env.REACT_APP_FE_URL ?? 'https://joinmytalent.krischey-schulz.de'
export const IS_PROD = process.env.REACT_APP_IS_PROD === 'true'
export const ENV_NAME = process.env.REACT_APP_ENV_NAME ?? 'dev'
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI ?? 'https://app.joinmytalent.com/login'
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? 'NIENTAYWtCstjC5xm5iGvIrgt7CdNDEtp32GCMad6Fk'
export const HSV_LOGIN_URL = process.env.REACT_APP_HSV_LOGIN_URL ?? 'https://hsv.staging.unidy.de'
